import get from 'lodash.get';

export const curationContainsItemsBySource = (curation, source) => {
  // Check at least one item contains the given source
  const packageContainsItemsBySource = (pkg) => {
    const items = get(pkg, 'items', []);
    return items.some(
      (item) => get(item, 'item.source.organization.name') === source,
    );
  };

  // Check at least one package contains matching source
  const layoutContainsItemBySource = (layout) => {
    const packages = get(layout, 'packages', []);
    return packages.some(packageContainsItemsBySource);
  };

  const layouts = get(curation, 'layouts', []);
  return layouts.some(layoutContainsItemBySource);
};

export default {
  curationContainsItemsBySource,
};
